import dynamic from 'next/dynamic';

const FooterWC = dynamic(() => import('./FooterWC'), { ssr: false });

const Footer = () => (
  <div className="h-[var(--outside-footer-height)] w-full bg-white">
    <FooterWC />
  </div>
);

export default Footer;
